module.exports = __webpack_public_path__ + "img/check-blue.c5fad853.svg";